import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['panel', 'toggleBtn'];

  toggle() {
    const panel = this.panelTarget;
    panel.hidden = !panel.hidden;
  }
}
